import {FC, useEffect} from "react";
import {useLocation} from "react-router-dom";
import Header from "./components/home/Header";
import Hero from "./components/home/Hero";
import NewFooter from "./components/home/NewFooter";
import {useMobileMenu} from "./contexts/MobileMenuProvider";
import MobileMenu from "./components/home/MobileMenu";
import Waitlist from "./components/home/Waitlist";
import InvestDialog from "./components/home/InvestDialog";
import { useAuthForm } from "./contexts/AuthFormProvider";

interface HomeProps {

}

// Component that handles auto-opening modals based on route
const HomeContent: FC = () => {
    const { showMenu } = useMobileMenu();
    const location = useLocation();
    const { showRegisterForm, showLoginForm, isOpen } = useAuthForm();

    useEffect(() => {
        console.log('🏠 [Home] useEffect triggered', {
            pathname: location.pathname,
            search: location.search,
            isOpen,
            timestamp: new Date().toISOString()
        });

        const searchParams = new URLSearchParams(location.search);
        const modal = searchParams.get('modal');

        // Only trigger modals if not already open
        if (!isOpen) {
            console.log('🏠 [Home] Modal not open, checking conditions...');
            // Auto-open register modal when on /signup route
            if (location.pathname === '/signup') {
                console.log('🏠 [Home] On /signup route, calling showRegisterForm()');
                showRegisterForm();
            }
            // Auto-open login modal when on /signin route
            else if (location.pathname === '/signin') {
                console.log('🏠 [Home] On /signin route, calling showLoginForm()');
                showLoginForm();
            }
            // Support URL parameters for modal opening
            else if (modal === 'signup') {
                console.log('🏠 [Home] URL param modal=signup, calling showRegisterForm()');
                showRegisterForm();
            }
            else if (modal === 'signin' || modal === 'login') {
                console.log('🏠 [Home] URL param modal=signin/login, calling showLoginForm()');
                showLoginForm();
            } else {
                console.log('🏠 [Home] No modal conditions met');
            }
        } else {
            console.log('🏠 [Home] Modal is already open, skipping triggers');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, location.search, isOpen]);

    return (
        <div className="bg-gradient-to-br from-gray-950 via-gray-900 to-black min-h-screen homepage overflow-x-hidden">
            {/* Particles are now handled by TsParticles in Hero component */}
            <div className="flex flex-col overflow-x-hidden">
                <Header/>
                <Hero/>
            </div>
            <NewFooter/>
            {showMenu && <MobileMenu/>}
            <InvestDialog/>
            <Waitlist/>
        </div>
    );
};

const Home: FC<HomeProps> = () => {
    return <HomeContent />;
};


export default Home;